import assert from 'assert';

export const LEASE_DOCUMENT_STATUS_CREATED = 'Created';
export const LEASE_DOCUMENT_STATUS_REVIEWED = 'Reviewed';
export const LEASE_DOCUMENT_STATUS_SENT = 'Sent';
export const LEASE_DOCUMENT_STATUS_SIGNED = 'Signed';
export const LEASE_DOCUMENT_STATUS_VOIDED = 'Voided';

export const LEASE_TYPE_SUNSETUP = 'SunSetup';

export const LEASE_DOCUMENT_STATUS_LIST = [
  LEASE_DOCUMENT_STATUS_CREATED,
  LEASE_DOCUMENT_STATUS_REVIEWED,
  LEASE_DOCUMENT_STATUS_SENT,
  LEASE_DOCUMENT_STATUS_SIGNED,
  LEASE_DOCUMENT_STATUS_VOIDED,
];

export const LEASE_GENERATION_SERVICE_PROVIDER_SIGNEASY = 'signeasy';

export const LEASE_GENERATION_SERVICE_PROVIDER_LIST = [
  LEASE_GENERATION_SERVICE_PROVIDER_SIGNEASY,
];

export const assertLeaseGenerationServiceSourceIsValid = (leaseGenerationServiceSource) => {
  assert(
    LEASE_GENERATION_SERVICE_PROVIDER_LIST.includes(leaseGenerationServiceSource),
    `Lease generation service source "${leaseGenerationServiceSource}" not supported.`
  );
};
